import { useMemo } from 'react';
import { Marker, type PointLike } from 'react-map-gl';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import ArrowSq from '@alltrails/denali/icons/ArrowSq';
import styles from './styles/styles.module.scss';

type Props = {
  currentIndex: number;
  resultCount: number;
  latitude: number;
  longitude: number;
  onNavigate: (currentIndex: number, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent) => void;
  isTrackStyle?: boolean;
  offset?: PointLike;
};

const MarkerCarousel = ({ currentIndex, resultCount, latitude, longitude, onNavigate, isTrackStyle = false, offset }: Props) => {
  const [carouselPinClassName, iconButtonClassName] = useMemo(() => {
    if (isTrackStyle) {
      return [styles.activityCarouselPin, styles.trackIconButton];
    }
    return [styles.trailCarouselPin, ''];
  }, [isTrackStyle]);

  return (
    <Marker latitude={latitude} longitude={longitude} offset={offset}>
      <div
        className={classNames(styles.trailheadMarker)}
        onClick={event => onNavigate(currentIndex, event)}
        onKeyDown={event => onNavigate(currentIndex, event)}
        tabIndex={0}
        role="button"
      >
        <div className={carouselPinClassName}>
          <IconButton
            className={iconButtonClassName}
            icon={{ Component: ArrowSq, orientation: 'left' }}
            title="previous"
            onClick={event => onNavigate(currentIndex - 1, event)}
            size="sm"
            testId="trailhead-previous"
            variant="primary"
          />
          <span className={styles.text}>
            {currentIndex + 1} <FormattedMessage defaultMessage="of" /> {resultCount}
          </span>
          <IconButton
            className={iconButtonClassName}
            icon={{ Component: ArrowSq, orientation: 'right' }}
            title="next"
            onClick={event => onNavigate(currentIndex + 1, event)}
            size="sm"
            testId="trailhead-next"
            variant="primary"
          />
        </div>
      </div>
    </Marker>
  );
};

export default MarkerCarousel;
